/** @jsxImportSource @emotion/react */
import React from "react";
import { Routes, Route } from "react-router-dom";
import Login from "./secciones/login/Login";
import RegistroEmpresa from "./secciones/registroempresa/RegistroEmpresa";
import BusquedaCertificado from "./secciones/busquedaCertificado/BusquedaCertificado";
import NotFound from "./secciones/notFound/NotFound";
import SolicitudCambioPassword from "./secciones/recuperarcontrasenia/solicitudCambioPassword";
import CambioPassword from "./secciones/recuperarcontrasenia/cambioPassword";
import DocumentosPublicos from "./secciones/documentosPublicos/DocumentosPublicos";
import MuestraPublica from "./secciones/muestraPublica/MuestraPublica";
import CajaPublica from "./secciones/cajaPublica/CajaPublica";
import MuestraUpload from "./secciones/muestraUpload/MuestraUpload";
import EnsayoPublico from "./secciones/ensayoPublico/EnsayoPublico";

class Router extends React.Component {
  render() {
    return (
      <div
        css={{
          marginLeft: "auto",
          marginRight: "auto",
          maxWidth: "1440px"
        }}
      >
        <Routes>
          <Route path="/registro" element={<RegistroEmpresa />} />
          <Route path="/cert" element={<BusquedaCertificado />} />
          <Route path="/c" element={<BusquedaCertificado />} />
          {/* Link directo a un certificado por su número impreso. Es a donde
              apuntan los QR de los certificados nuevos. */}
          <Route
            path="/c/:numeroCertificado"
            element={<BusquedaCertificado />}
          />
          {/* Compatibilidad: los QR ya impresos apuntan a /c/{letra}/{numero}.
              La API rearma CP-{letra}-{numero} y busca ese certificado. */}
          <Route
            path="/c/:certificadoTipo/:certificadoNumero"
            element={<BusquedaCertificado />}
          />
          <Route path="/documentos" element={<DocumentosPublicos />} />
          <Route path="/d" element={<DocumentosPublicos />} />
          <Route path="/m/:hash" element={<MuestraPublica />} />
          <Route path="/m/upload/:hashUpload" element={<MuestraUpload />} />
          <Route path="/caja/:hash" element={<CajaPublica />} />
          <Route path="/E/:numero" element={<EnsayoPublico />} />
          <Route path="/" element={<Login />} />
          <Route path="*" element={<NotFound />} />
          <Route
            path="/solicitudCambioPassword"
            element={<SolicitudCambioPassword />}
          />
          <Route path="/cc/:token" element={<CambioPassword />} />
        </Routes>
      </div>
    );
  }
}

export default Router;
